import { Loader } from "@components/Loader"
import React from "react"
import { protectedService } from "@services/authentication/protected"
import { useSelector } from "react-redux"
import { Navigate } from "react-router"
import { useState, useEffect } from "react"

const ProtectAuthPage = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null)
  
    useEffect(() => {
      const verifyAuth = async () => {
        try {
          await protectedService()
          setIsAuthenticated(true)
        } catch (error) {
          setIsAuthenticated(false)
        }
      }
      verifyAuth()
    }, [])
  
    if (isAuthenticated === null) {
      return null
    }
  
    if (isAuthenticated) {
      return <Navigate to="/chooseview" replace />
    }
  
    return children
  }

export default ProtectAuthPage
